// import { SearchBox } from 'eymp-uicomps';
import { Button } from 'eymp-uicomps';
import React, { useEffect, useState } from 'react';
import SearchIcon from '../../../assets/dashboardIcons/SearchIcon.png';
import ToolTip from 'src/ui/library/ToolTip';

const Searchbar = props => {
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    if (props.onSearch) {
      props.onSearch(searchText);
    }
  }, [searchText]);

  const handleSearch = event => {
    const newValue = event.target.value;
    setSearchText(newValue);
    // this.setState(
    //   {
    //     searchText: newValue,
    //     announceText: intl.get('table.labels.showingResultsFor') + newValue || intl.get('table.labels.showingAllResults'),
    //   },
    //   () => {
    //     if (this.props.onSearch) {
    //       this.props.onSearch(newValue);
    //     }
    //   },
    // );
  };

  return (
    <div className="w-100">
      <ToolTip title="Search..." hideButton={true} placement="bottom-start">
        <div className="floating-label-group">
          <input
            type="text"
            id="search"
            title={searchText}
            className="form-control"
            autocomplete="off"
            value={searchText}
            onChange={handleSearch}
            autofocus
            required
          />
          <Button>
            <img src={SearchIcon} />
          </Button>
          <label className="floating-label">Search...</label>
        </div>
      </ToolTip>
    </div>
  );
};

export default Searchbar;
